import { Box, Grid, PaletteColor, styled, ToggleButton, ToggleButtonGroup, Typography, useTheme } from "@mui/material";
import * as React from "react";
import "./images/arrow-up-min.png";

const ToggleButtonWithColour = styled(ToggleButton, {
  shouldForwardProp: (prop) => prop !== "colourPalette",
})<{
  colourPalette?: PaletteColor;
}>(({ theme, colourPalette }) =>
  colourPalette
    ? {
        backgroundColor: "#fff", // to override the 'secondary' button background colour'
        "&.Mui-selected": {
          backgroundColor: colourPalette?.main,
          border: `${colourPalette?.dark || theme.palette.greys.main} 1px solid !important`,
          color: colourPalette?.contrastText || "#fff", // as per TTRSUPP-238 requirements, all selected buttons should have white text
        },
        "&.Mui-selected:hover": {
          backgroundColor: colourPalette?.main,
          color: colourPalette?.contrastText || "#fff",
        },
        "&:not(.Mui-selected):hover": {
          backgroundColor: theme.palette.greys.grey300,
          transition: "background-color 0.1s ease-in-out",
        },
      }
    : {}
);

export function MakeItMonthlyButtons(props: {
  isRegular: boolean;
  setIsRegular: (arg: boolean) => void;
  donationFrequencyButtonColour?: string;
  spaceBetweenDonationFrequencyButtons?: boolean;
}) {
  const handleButtonChange = (_: React.MouseEvent<HTMLElement>, newValue: boolean) => {
    if (newValue !== null) {
      props.setIsRegular(newValue);
    }
  };

  const theme = useTheme();
  const palette = theme.palette as unknown as Record<string, PaletteColor>;
  const buttonColourPalette: PaletteColor | undefined = props.donationFrequencyButtonColour
    ? palette[props.donationFrequencyButtonColour]
    : undefined;

  return (
    <>
      <ToggleButtonGroup
        fullWidth
        value={props.isRegular}
        exclusive
        onChange={handleButtonChange}
        aria-label="Make It Monthly Donation Buttons"
        sx={
          props.spaceBetweenDonationFrequencyButtons
            ? {
                display: "grid",
                gridAutoFlow: "column",
                gridAutoColumns: "minmax(0, 1fr)",
                gridGap: "0.6rem",
                "& .MuiToggleButton-root": {
                  borderRadius: 1,
                  border: `${theme.palette.greys.main} 1px solid`,
                },
              }
            : {}
        }
      >
        <ToggleButtonWithColour
          value={false}
          aria-label="one-off donation"
          color="secondary"
          colourPalette={buttonColourPalette}
        >
          <Typography variant="subtitle1" whiteSpace="nowrap">
            Chip In Once
          </Typography>
        </ToggleButtonWithColour>
        <ToggleButtonWithColour
          value={true}
          color="secondary"
          aria-label="monthly donation"
          colourPalette={buttonColourPalette}
        >
          <Typography variant="subtitle1" whiteSpace="nowrap">
            Chip In Monthly
          </Typography>
        </ToggleButtonWithColour>
      </ToggleButtonGroup>

      <Grid container justifyContent="flex-end" width="75%" marginTop="1rem">
        <Box
          component="img"
          sx={{
            width: 18,
          }}
          alt="arrow pointing up"
          src="/arrow-up-min.png"
        />
      </Grid>

      <Typography align="center" variant="body1">
        Make a <strong>bigger</strong> impact by repeating your donation monthly
      </Typography>
    </>
  );
}
